import { Link } from "react-router-dom";
import { hotTags } from "@/mocks/tags";

export default function TagCloud() {
  const sizes = ["text-sm", "text-sm", "text-base", "text-base", "text-lg"];

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="text-center max-w-2xl mx-auto mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门话题标签</h2>
        <p className="mt-2 text-sm md:text-base text-foreground-600">
          点击标签，发现更多正在被讨论的内容
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-3 max-w-4xl mx-auto">
        {hotTags.map((tag, i) => (
          <Link
            key={tag.name}
            to={`/search?q=${encodeURIComponent(tag.name)}`}
            className={`inline-flex items-center gap-1.5 h-10 px-4 rounded-full border transition-colors whitespace-nowrap cursor-pointer ${
              i % 3 === 0
                ? "bg-primary-100 border-primary-200 text-primary-800 hover:bg-primary-200"
                : i % 3 === 1
                ? "bg-accent-100 border-accent-200 text-accent-800 hover:bg-accent-200"
                : "bg-secondary-100 border-secondary-200 text-secondary-800 hover:bg-secondary-200"
            } ${sizes[i % sizes.length]}`}
          >
            <span className="font-medium">#{tag.name}</span>
            <span className="text-xs opacity-70">{tag.hot}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}